// The knowledge base API's refusals, as the user reads them.
const REASONS = {
  INVALID_KIND: "surveySettings.knowledge.error_kind",
  TRIGGER_REQUIRED: "surveySettings.knowledge.error_trigger",
  RESPONSE_REQUIRED: "surveySettings.knowledge.error_response",
  INVALID_AFTER_ACTION: "surveySettings.knowledge.error_after",
  KNOWLEDGE_LIMIT_REACHED: "surveySettings.knowledge.error_limit",
  survey_read_only: "surveySettings.knowledge.error_read_only",
};

export function knowledgeErrorText(t, res) {
  const key = REASONS[res?.reason] || (res?.httpStatus === 403 ? "surveySettings.knowledge.error_forbidden" : null);
  return t(key || "surveySettings.knowledge.error_generic");
}
